import { useEffect, useMemo, useState } from 'react'
import { type CountdownParts, countdownParts } from '../lib/countdown.js'

export function useCountdown(targetIso: string, active: boolean): CountdownParts {
  const target = useMemo(() => new Date(targetIso).getTime(), [targetIso])
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    if (!active) return
    const id = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(id)
  }, [active])

  return countdownParts(target, now)
}
